import React, { PureComponent, Fragment } from 'react';
import cx from 'classnames';
import throttle from 'lodash.throttle';

import { H1, P } from '../BaseElements/BaseElements';
import { isPreRendering, fireGATrackingEvent } from '../../common/utils.js';

import s from './styles/Hero.module.scss';

class Hero extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      mobileMode: this.getViewMode(),
      ie11: !!window.MSInputMethodContext && !!document.documentMode,
    };

    this.onResizeThrottled = throttle(this.onResize, 100);
  }

  onResize = () => {
    this.setViewMode();
  };

  getViewMode = () => !window.matchMedia('(min-width: 768px)').matches;
  setViewMode = () => {
    this.setState({
      mobileMode: this.getViewMode(),
    });
  };

  componentDidMount = () => {
    window.addEventListener('resize', this.onResizeThrottled);
    this.setViewMode();
  };

  componentDidUnMount = () => {
    window.removeEventListener('resize', this.onResizeThrottled);
  };

  render = () => {
    const { mobileMode, ie11 } = this.state;
    const heroCopy = (
      <Fragment>
        <div className={s.contentWrapper}>
          <div className={cx(s.col, s.headerCol)}>
            <H1 className={s.heading}>Maximize your brand’s full potential.</H1>
          </div>
          <div className={cx(s.col, s.contentCol)}>
            <P>
              The Adaptive Brand Playbook: enable your brand to thrive in a
              constantly fluctuating world by nimbly evolving to seize
              potential. As a result of enthusiastic industry response, we have
              shipped all available Brand Playbooks. We invite you to explore
              how we think differently about life sciences brands on{' '}
              <a
                href="https://www.klick.com"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => {
                  fireGATrackingEvent(
                    'Outbound Links',
                    'Click',
                    'https://www.klick.com'
                  );
                }}
              >
                klick.com
              </a>
              .
            </P>
          </div>
        </div>
      </Fragment>
    );

    return (
      <div className={s.Hero} id="hero">
        <div className={s.videoBg}>
          {!isPreRendering && mobileMode && !ie11 && (
            <video
              poster="/images/playbook-loop-poster-mobile.jpg"
              src="/videos/playbook-loop-mobile.mp4"
              autoPlay
              loop
              muted
              playsInline
            />
          )}

          {!isPreRendering && !mobileMode && !ie11 && (
            <video
              poster="/images/playbook-loop-poster.jpg"
              src="/videos/playbook-loop.mp4"
              autoPlay
              loop
              muted
              playsInline
            />
          )}

          {!isPreRendering && ie11 && (
            <video
              poster="/images/playbook-loop-poster.jpg"
              src="/videos/playbook-loop-720.mp4"
              autoPlay
              loop
              muted
              playsInline
            />
          )}
        </div>
        <div className={cx(s.content)} id="herocontent">
          <div className={s.contentInner}>{heroCopy}</div>
        </div>
      </div>
    );
  };
}

export default Hero;
